import { render, staticRenderFns } from "./PhraseGoodness.vue?vue&type=template&id=59b8b7f1&scoped=true"
import script from "./PhraseGoodness.vue?vue&type=script&lang=js"
export * from "./PhraseGoodness.vue?vue&type=script&lang=js"
import style0 from "./PhraseGoodness.vue?vue&type=style&index=0&id=59b8b7f1&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b8b7f1",
  null
  
)

export default component.exports